import React, { Component } from 'react';
import withRouter from '../../helpers/withWrapper'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import levelPrices from "../../services/levelPrice";
import getWallet from "../../services/wallet";
import { getGlobalRewardContract, getOwnerContract } from "../../services/contract";
import getContract from "../../services/contract";

import moment from "moment";
import { ethers } from 'ethers';

class Pools extends Component {
    state = {
        contract: null,
        shareInfos: [],
        currentPoolId: 0,
        totalShares: 0,
        timeLeftToClaim: '30 d'
    }

    constructor(props) {
        super(props);
        if(props.router.params.id) {
            this.state.userId = props.router.params.id;
        } else {
            this.state.userId = 1;
        }
        this.props.onSetUserId(this.state.userId);
    }


    async componentDidMount(props) {
      try {
                
        const promise = this.initializeState();
            await toast.promise(
              promise,
                {
                  pending: 'Fetching All Sales',
                  success: 'All Sales Fetched! 👌',
                  error: 'Fetching All Sales failed'
                }
            )
      } catch (error) {
        console.log(error);
      }
    }

    async initializeState() {
      const wallet = await getWallet();
      let contract;
      contract = await getGlobalRewardContract();

      const currentPoolId = ethers.BigNumber.from(await contract.currentPoolNumber()).toNumber();

      // const timeLeftInEpoch = ethers.BigNumber.from(
      //   await contract.getCurrentPoolTimeLeft()
      // ).toNumber();

      const currentPoolStartTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolStartTime(currentPoolId)).toNumber();

      // const claimPeriodInEpoch_inSec = ethers.BigNumber.from(await contract.claimPeriod()).toNumber();
      const poolEndTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolEndTime(currentPoolId)).toNumber();
      
      const claimPeriod_inMiliSec = (poolEndTimeInEpoch_inSec) * 1000;      


      const totalSharesBN = await contract.totalShares();
      const totalShares = ethers.BigNumber.from(totalSharesBN).toNumber();
      console.log("Total Shares ", totalShares);

      const amountPerPoolBN = await contract.amountPerPool(currentPoolId);
      const amountPerPool = parseFloat(ethers.utils.formatUnits(amountPerPoolBN)).toFixed(2);

      const sharesPerPoolBN = await contract.totalSharesPerPool(currentPoolId);
      const sharesPerPool = ethers.BigNumber.from(sharesPerPoolBN).toNumber();

      const isEligible = await contract.isEligible(this.state.userId);

      let totalShareIncomeEarned = 0.00;
      if(isEligible) {
        totalShareIncomeEarned = parseFloat(ethers.utils.formatUnits(await contract.getAllShareIncome(this.state.userId))).toFixed(2);
      }
      // const totalIncomeUnClaimed = await contract.getAllUnClaimedShareIncome(this.state.userId)

      let shareInfos = [];
      if(isEligible) {
        for(let i = 1; i <= currentPoolId; i++) {
          const shareInfoResponse = await contract.getShareInfo(this.state.userId, i);

          const poolId = i;
          const shareIncome = parseFloat(ethers.utils.formatUnits(shareInfoResponse[0])).toFixed(2);
          const userShare = ethers.BigNumber.from(shareInfoResponse[1]).toString();

          const totalShareInPool = ethers.BigNumber.from(shareInfoResponse[2]).toString();
          const startTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[3]).toNumber()
          ).toDateString();
          const endTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[4]).toNumber()
          ).toDateString();
          const claimable = shareInfoResponse[5];
          const isClaimed = shareInfoResponse[6];
          const isEligibleForPool = shareInfoResponse[7];
          
          const amountPerPool = parseFloat(ethers.utils.formatUnits(await contract.amountPerPool(poolId))).toFixed(2);

          if(isEligibleForPool) {
            shareInfos.push({poolId, shareIncome, userShare, totalShareInPool, startTime, endTime, claimable, isClaimed, amountPerPool});
          }

        }
      }
      
      const userCurrentPoolShares = ethers.BigNumber.from(
        await contract.getCorrectUserShareInPool(this.state.userId, currentPoolId)
      ).toNumber();
      
      let currentPoolIncome = 0.00;
      if(isEligible) {
        currentPoolIncome = +shareInfos[shareInfos.length-1].shareIncome;
      }

      const sharePercent = (userCurrentPoolShares / totalShares * 100).toFixed(2);

      // const userTotalShares = ethers.BigNumber.from(
      //   await constract.userTotalShares(this.state.userId)
      // ).toString();

      shareInfos = shareInfos.sort((a, b) => b.poolId - a.poolId);

      let timeLeftToClaim = '';
      
      const startDate = Date.now();
      let formatDate = moment.duration(claimPeriod_inMiliSec - startDate)
      
      if (formatDate && (claimPeriod_inMiliSec >= startDate)) {
          if ( formatDate.months() > 0 ) {
              timeLeftToClaim = `${Math.round(formatDate.asDays())}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
          else {
              timeLeftToClaim = `${formatDate.days()}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
      } else {
        timeLeftToClaim = "0d 0h 0m"
      }

      if (totalShares == 0) {
        timeLeftToClaim = "0d 0h 0m"
      }

      this.setState({totalShares, currentPoolId, amountPerPool, userCurrentPoolShares, currentPoolIncome, 
        timeLeftToClaim, sharePercent, shareInfos, totalShareIncomeEarned, contract})
    }

    async claimReward(poolId) {
      
      try {
        const wallet = await getWallet();
          if(wallet.isReadOnly) {
              alert("Please connect your wallet");
              return;
          }
          
            let contract = (this.state.userId == 1) ? await getContract() : this.state.contract;
            // const claimRewardPromise = contract.claimRewards(this.state.userId, poolId, 
            //   {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
            
            let claimRewardPromise = (this.state.userId == 1) ? contract.claimRewards(poolId) : contract.claimRewards(this.state.userId, poolId);
            await toast.promise(
              claimRewardPromise,
                {
                  pending: 'Claiming Rewards in progress',
                  success: 'Rewards Sent to You!',
                  error: 'Claim Rewards failed'
                }
            )

          await this.initializeState();
      } catch (error) {
        alert(error.reason)
      }
    }

    getDateInMiliSecFromSec(x) {
        const myDate = new Date(x * 1000);
        return myDate;
     }

    render() {


        return (
          <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-black pt-20 sm:pt-14"
            style={{ background: "linear-gradient(135deg, #0D0B1A, #1A103C, #0D0B1A)", minHeight: "100vh" }}
          >
            {/* <ToastContainer position="bottom-right" /> */}
            <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
              {/* Top Panel, Matrix levels and all activities inside below div */}
              <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                {/* Top panel of Dashboard mobile view inside below div - Themed */}
                <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                  <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                    <div className="flex-shrink-0 relative w-30 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                      <div className="w-26 h-16 sm:h-14 sm:w-14 rounded-full p-2">
                        <img src="/logo/logo.png" className="w-full h-full object-contain drop-shadow-lg" alt="Crypto Digital For Life" />
                      </div>
                    </div>
                    <div className="flex flex-col items-start ml-6 h-full justify-center my-auto" >
                      <div className="flex justify-center items-center mb-1 sm:mb-2.5">
                        <h3 style={{color: "white"}} className="font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
                          All Sales - ID {this.state.userId}
                        </h3>
                      </div>
                      <div className="flex flex-col items-start">
                        <div className="flex items-center mb-1">
                          <span className="text-gray-300 font-bold mr-2.5 text-base sm:text-sm showWalletAddress bg-gray-800/50 px-3 py-1 rounded-full">
                            Current running Pool number is {this.state.currentPoolId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Eligibility Card - Themed */}
                  <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="relative flex flex-grow max-w-500px w-full h-full flex-col p-5 justify-between bg-gray-800/50 backdrop-blur-sm rounded-2xl border border-cyan-500/30 shadow-xl sm:max-w-full">
                    <div className="flex items-center">
                      <div className="w-2 h-2 rounded-full bg-cyan-400 mr-2 animate-pulse"></div>
                      <h3 className="text-cyan-400 text-lg sm:text-sm font-semibold">
                        All Sales Eligibility:
                      </h3>
                    </div>
                    <div className="md:flex flex-wrap justify-between false">
                      <span className="text-gray-200 text-lg font-bold lg:mb-2.5 sm:text-xl">
                        For Eligibility of All Sales, User must be in Star 8 - 15
                      </span>
                    </div>
                  </div>
                </div>
                {/* Top panel of Dashboard mobile view inside above div */}

                {/* Stats Cards - Redesigned with gradient backgrounds */}
                <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                  <div className="flex w-full flex-wrap lg:flex-col">
                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                      
                      {/* Total Shares */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow flex flex-col p-5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/20 shadow-lg hover:shadow-cyan-500/10 transition-all duration-300">
                        <div className="flex items-center">
                          <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center mr-3">
                            <svg className="w-4 h-4 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-300 text-base sm:text-sm">Total Shares</h4>
                        </div>
                        <span className="text-white text-3xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.totalShares}
                        </span>
                      </div>
                      
                      {/* Total Amount in current pool */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow flex flex-col p-5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/20 shadow-lg hover:shadow-cyan-500/10 transition-all duration-300">
                        <div className="flex items-center">
                          <div className="w-8 h-8 rounded-full bg-purple-500/20 flex items-center justify-center mr-3">
                            <svg className="w-4 h-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-300 text-base sm:text-sm">Total Amount in Pool</h4>
                        </div>
                        <span className="text-white text-3xl font-bold sm:text-xl mt-5 sm:mt-2.5" id="yourTeamTreeCount">
                          {this.state.amountPerPool} <span className="text-sm text-gray-400">USDT</span>
                        </span>
                      </div>
                      
                      {/* My Shares */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow flex flex-col p-5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/20 shadow-lg hover:shadow-cyan-500/10 transition-all duration-300">
                        <div className="flex items-center">
                          <div className="w-8 h-8 rounded-full bg-yellow-500/20 flex items-center justify-center mr-3">
                            <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-300 text-base sm:text-sm">My Shares</h4>
                        </div>
                        <span className="text-white text-3xl font-bold sm:text-xl mt-5 sm:mt-2.5" id="yourTeamTreeCount">
                          {this.state.userCurrentPoolShares}
                        </span>
                      </div>
                      
                      {/* My Current pool income */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/20 shadow-lg hover:shadow-cyan-500/10 transition-all duration-300">
                        <div className="flex items-center">
                          <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mr-3">
                            <svg className="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                            </svg>
                          </div>
                          <h4 className="text-gray-300 text-base sm:text-sm">My Pool Income</h4>
                        </div>
                        <span className="text-white text-3xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.currentPoolIncome} <span className="text-sm text-gray-400">USDT</span>
                        </span>
                      </div>
                      
                      {/* My Share Percent */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/20 shadow-lg hover:shadow-cyan-500/10 transition-all duration-300">
                        <div className="flex items-center">
                          <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mr-3">
                            <svg className="w-4 h-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-300 text-base sm:text-sm">My Share Percent</h4>
                        </div>
                        <span className="text-white text-3xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.sharePercent} <span className="text-sm text-gray-400">%</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Second Row Stats */}
                <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                  <div className="flex w-full flex-wrap lg:flex-col">
                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                      
                      {/* Total Earned */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow sm:max-w-full flex flex-col p-6 bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/30 shadow-xl">
                        <div className="flex items-center">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 flex items-center justify-center mr-3">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-200 text-lg sm:text-sm font-semibold">Total Earned from All Sales</h4>
                        </div>
                        <span style={{color: "white"}} className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 text-4xl font-bold sm:text-2xl mt-5 sm:mt-2.5">
                          {this.state.totalShareIncomeEarned} <span className="text-xl text-gray-400">USDT</span>
                        </span>
                      </div>
                      
                      {/* Time Left */}
                      <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="lg:flex-grow sm:max-w-full flex flex-col p-6 bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl border border-cyan-500/30 shadow-xl">
                        <div className="flex items-center">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-yellow-500 to-orange-600 flex items-center justify-center mr-3">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h4 className="text-gray-200 text-lg sm:text-sm font-semibold">Time Left to Claim Current Pool</h4>
                        </div>
                        <span className="text-yellow-400 text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.timeLeftToClaim}
                        </span>
                      </div>
                    </div>
                    
                  </div>
                </div>
                {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}
              </div>
              
              {/* All Sales Pools History Section - Themed */}
              <h1 style={{color: "white"}} className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 text-3xl font-bold mt-10 mb-5 text-center">
                All Sales Pools History
              </h1>
              
              <div style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }} className="sm:rounded-none z-10 flex flex-1 flex-col w-full bg-gray-800/30 backdrop-blur-sm rounded-2xl overflow-hidden h-full min-h-90 sm:max-h-3/4 border border-cyan-500/20">
                <div className="overflow-auto">
                  <table className="min-w-max w-full table-auto">
                    <thead>
                      <tr className="text-gray-300 text-xs border-b border-cyan-500/20 bg-gray-800/50">
                        <th className="p-4 text-left font-normal sm:p-3">Pool No</th>
                        <th className="p-4 text-left font-normal sm:p-3">Start Date</th>
                        <th className="p-4 text-left font-normal sm:p-3">End Date</th>
                        <th className="p-4 text-left font-normal sm:p-3">Income</th>
                        <th className="p-4 text-right font-normal sm:p-3">Share in pool</th>
                        <th className="p-4 text-right font-normal sm:p-3">Total pool amount</th>
                        <th className="p-4 text-right font-normal sm:p-3">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-400 text-sm font-light align-baseline">
                      {this.state.shareInfos.map((a, index) => {
                        return (
                          <tr key={index} className="border-b border-cyan-500/10 last:border-none hover:bg-cyan-500/5 transition-all duration-200">
                            <td className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-cyan-400 text-sm font-semibold">
                                #{a.poolId}
                              </div>
                            </td>
                            <td className="p-2 text-left whitespace-nowrap sm:p-3">
                              <span className="flex items-left justify-center px-2.5 py-1 bg-cyan-500/10 text-cyan-400 rounded-lg font-medium text-sm w-max">
                                {a.startTime}
                              </span>
                            </td>
                            <td className="p-2 text-left whitespace-nowrap sm:p-3">
                              <span className="flex items-center justify-center px-2.5 py-1 bg-purple-500/10 text-purple-400 rounded-lg font-medium text-sm w-max">
                                {a.endTime}
                              </span>
                            </td>
                            <td className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-green-400 text-sm text-left font-semibold">
                                {a.shareIncome} USDT
                              </div>
                            </td>
                            <td className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-right">
                                {a.userShare}
                              </div>
                            </td>
                            <td className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-yellow-400 text-sm text-right font-semibold">
                                {a.amountPerPool} USDT
                              </div>
                            </td>
                            {a.claimable && !a.isClaimed ? (
                              <td className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right">
                                  <button
                                    onClick={() => this.claimReward(a.poolId)}
                                    className="flex items-center text-center text-base font-bold rounded-xl sm:text-sm outline-none py-2 px-4 bg-gradient-to-r from-cyan-600 to-blue-600 text-white hover:from-cyan-700 hover:to-blue-700 active:from-cyan-800 active:to-blue-800 shadow-lg hover:shadow-cyan-500/30 transition-all duration-200 w-max flex-shrink-0"
                                  >
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Claim
                                  </button>
                                </div>
                              </td>
                            ) : a.isClaimed ? (
                              <td className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-green-500 text-sm text-right font-semibold flex items-center justify-end">
                                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                  </svg>
                                  Claimed
                                </div>
                              </td>
                            ) : (
                              <td className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-gray-500 text-sm text-right"></div>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default withRouter(Pools);